import React, { Component } from "react";

import LinkPdf from '../tools/LinkPdf'

class EstadoArte extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <>
                <section id="insideDoc">
                    <h2>Etat des connaissances</h2>
                    <p>Ce document contient l’évidence scientifique au niveau mondial des avantages, de la portée et des limites des différents éléments de la Méthode Mère Kangourou, parmi lesquels figurent : i) la position kangourou, ii) la nutrition kangourou basé sur l’allaitement maternel et iii) la sortie rapide de l’hôpital et le suivi ambulatoire. Il présente également les aspects psychosociaux et l'acceptation et résistance des deux parents et du personnel de santé pour la mise en œuvre de la Méthode Mère Kangourou dans un hôpital en particulier. Cette révision bibliographique fournit également une mise à jour quant au développement théorique et pratique de cette méthode.</p>

                    <ul className="descarga">
                        <li>
                            <a className="link" href={process.env.PUBLIC_URL + '/docs/etat-connaissances/etat.ppt'}>Télécharger la présentation</a>
                        </li>
                    </ul>

                    <ul className="descarga">
                        <LinkPdf link="http://fundacioncanguro.co/-KMCT/kitEn/estado/index.html" titulo="Interactive book on the web (requires flash)" pdf={process.env.PUBLIC_URL + '/docs/etat-connaissances/etat.pdf'} />
                    </ul>
                </section>
            </>
        )
    }
}

export default EstadoArte;